import moment from "moment";

export const formatDateForServer: (momentInstance: moment.Moment) => string = (
  momentInstance
) => {
  return moment(momentInstance).format("YYYY-MM-DD");
};

export const humanizeNumbers: (
  number: number,
  hideDecimal?: boolean,
  compact?: boolean,
  decimalPlaces?: number
) => string = (number, hideDecimal, compact, decimalPlaces = 2) => {
  let divisor: number = 1;
  let identifier: string = "";
  if (number >= 1_000 && number < 1_00_000) {
    divisor = 1_000;
    identifier = "K";
  } else if (number >= 1_00_000 && number < 1_00_00_000) {
    divisor = 1_00_000;
    identifier = "L";
  } else if (number >= 1_00_00_000) {
    divisor = 1_00_00_000;
    identifier = "Cr";
  }

  const _n = compact ? number / divisor : number;
  const suffix = compact ? " " + identifier : "";
  const maximumFractionDigits = hideDecimal ? 0 : decimalPlaces;

  return Number(_n).toLocaleString("en-IN", { maximumFractionDigits }) + suffix;
};

export const replaceAll = (str: string, find: string, replace: string) =>
  str.replace(new RegExp(find, "g"), replace);
